import LegalContentPage from './LegalContentPage';

export default function PrivacyPolicyPage() {
  return <LegalContentPage type="privacy-policy" />;
}
